module.exports = __webpack_public_path__ + "img/bg.a0afcf55.png";